<div class="login-page">
  <div
    class="container-fluid d-flex justify-content-center align-items-center vh-100"
    *ngIf="!blockingMessage; else blockedTpl"
  >
    <div class="login-container">
      <img src="logo/logo.png" alt="Logo" class="logo" />

      <form [formGroup]="accountCheckForm" *ngIf="checkUserStep" (ngSubmit)="submitAccountCheck()">
        <div class="input-group">
          <label for="email">Email</label>
          <input
            type="email"
            id="email"
            formControlName="email"
            class="form-control"
            placeholder="Enter your email"
            autocomplete="username"
          />
        </div>

        <div class="forgot-password-container mb-2">
          <a class="forgot-password" (click)="forgotPassword()">Forgot password?</a>
        </div>

        <button
          type="submit"
          class="btn login-btn mt-3 w-100"
          [disabled]="accountCheckForm.invalid || loadingCheck"
        >
          <ng-container *ngIf="!loadingCheck; else checkingTpl">
            Check Account
          </ng-container>

          <ng-template #checkingTpl>
            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
            Checking...
          </ng-template>
        </button>
      </form>

      <form [formGroup]="loginForm" *ngIf="!checkUserStep">
       <div class="input-group" *ngIf="showPassword">
  <label for="password">Password</label>

  <input
    type="password"
    id="password"
    formControlName="password"
    class="form-control"
    placeholder="Enter your password"
    autocomplete="current-password"
  />
</div>

        <div class="input-group" *ngIf="showSpaceSelector">
          <label for="spaceSelect">Select a space</label>
          <select
            id="spaceSelect"
            class="form-control"
            formControlName="space_id"
          >
            <option [ngValue]="null" disabled>Select a space</option>
            <option
              *ngFor="let space of availableSpaces"
              [ngValue]="space.space_id"
            >
              {{ space.name }}
            </option>
          </select>
        </div>

        <div class="forgot-password-container mb-2">
          <a class="forgot-password" (click)="forgotPassword()">Forgot password?</a>
        </div>

        <button
          type="button"
          class="btn login-btn mt-3 w-100"
          (click)="continueLoginProfile()"
          [disabled]="loadingLogin || !loginForm.value.space_id || !loginForm.value.password"
          *ngIf="showSpaceSelector && showPassword"
        >
          <ng-container *ngIf="!loadingLogin; else loginLoadingTpl">
            Login
          </ng-container>
        </button>

        <button
          type="button"
          class="btn login-btn mt-3 w-100"
          (click)="continueLoginCommunity()"
          [disabled]="loadingLogin || !loginForm.value.password"
          *ngIf="!showSpaceSelector && showPassword && userInSlugCommunity"
        >
          <ng-container *ngIf="!loadingLogin; else loginLoadingTpl">
            Login
          </ng-container>
        </button>

        <button
          type="button"
          class="btn login-btn mt-3 w-100"
          (click)="continueExistingUserCommunityRegistration()"
          [disabled]="loadingLogin || !loginForm.value.password"
          *ngIf="!showSpaceSelector && showPassword && !userInSlugCommunity"
        >
          <ng-container *ngIf="!loadingLogin; else loginLoadingTpl">
            Login
          </ng-container>
        </button>

        <ng-template #loginLoadingTpl>
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          Logging in...
        </ng-template>
      </form>
    </div>
  </div>
</div>

<ng-template #blockedTpl>
  <div class="container-fluid d-flex justify-content-center align-items-center vh-100">
    <div class="login-container text-center p-4">
      <img src="logo/logo.png" alt="Logo" class="logo mb-3" />
      <h3 class="mb-2 blockHeading">We couldn’t log you in</h3>
      <p class="mb-4 blockText">{{ blockingMessage }}</p>

      <div class="d-flex gap-2 justify-content-center">
        <button
          type="button"
          class="btn login-btn btn-outline-secondary"
          (click)="blockedAccountBack()"
        >
          Back
        </button>
      </div>
    </div>
  </div>
</ng-template>